import React from 'react';

import PricingPromoCircle from 'Components/PricingPromoCircle';
import styles from './PageHeader.scss';

const PageHeader = ({ title, description, type }) => {
  return (
    <header className={`PageHeader ${type ? `PageHeader--${type}` : ''}`}>
      <div className="PageHeader__text">
        <h2 className="PageHeader__title">{title}</h2>
        {description ? (
          <p className="PageHeader__description">{description}</p>
        ) : null}
      </div>
      {type === 'pricing' ? <PricingPromoCircle /> : null}
    </header>
  );
};
export default PageHeader;
